module.exports = __webpack_public_path__ + "img/tante Riek_wolk_600x600px.cf3ac311.png";